// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kz-1";
export var stateContainer = "_kz-0";